/**
 * This function updates a specific key in an object with a new value.
 * It creates a new object with the updated value
 * while keeping the rest of the properties unchanged.
 *
 * @param {Object} originalObject - The original object to be updated.
 * @param {string} keyToUpdate - The key of the property to be updated.
 * @param {any} newValue - The new value to set for the specified key.
 *
 */
export const updateObjectValue = (originalObject, keyToUpdate, newValue) => {
    // Check if the keyToUpdate exists in the originalObject
    return {
        ...originalObject,
        [keyToUpdate]: newValue,
    };
};

/**
 * This function replaces an object in an array with a new object
 * based on a specified object ID.
 * It creates a new array with the updated object
 * while keeping the rest of the objects unchanged.
 *
 * @param {Array} array - The original array of objects.
 * @param {string} objectId - The ID of the object to be replaced.
 * @param {Object} newObject - The new object to replace the old one.
 * @returns {Array} - A new array with the updated object.
 */
export const replaceObjectInArray = (array, objectId, newObject) => {
    // Find the index of the object to be replaced
    const index = array.findIndex((obj) => obj.id === objectId);

    // If the object is found, create a new array with the updated object
    if (index !== -1) {
        return [...array.slice(0, index), newObject, ...array.slice(index + 1)];
    }
    return array;
};
